import { useEffect } from 'react';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { getProfileSeo } from 'src/utils/seo';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import { DefaultLayout } from 'src/components/layouts';
import ProfileContent from 'src/modules/user/profile/components/profileContent';
import { H1 } from 'styles-js/mixins/screenReader';
import ProfileHeader from 'src/modules/user/profile/components/profileHeader';
export type props = {
  username: string;
};
export default function ProfilePage({
  username
}: props) {
  const {
    userImageHash
  } = useSelector(({
    pages
  }) => pages.profile.basics);
  const userViewedId = useSelector(({
    pages
  }) => pages.profile.profileUser?.userId);
  useEffect(() => {
    trackFootfallEvent(Event.ViewedUser, {
      userViewedId
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <DefaultLayout seo={getProfileSeo(username, userImageHash)} data-sentry-element="DefaultLayout" data-sentry-component="ProfilePage" data-sentry-source-file="profilePage.tsx">
      <H1 data-sentry-element="H1" data-sentry-source-file="profilePage.tsx">{i18n.t('User Profile')}</H1>
      <ProfileHeader data-sentry-element="ProfileHeader" data-sentry-source-file="profilePage.tsx" />
      <ProfileContent data-sentry-element="ProfileContent" data-sentry-source-file="profilePage.tsx" />
    </DefaultLayout>;
}